import { createClient } from "@supabase/supabase-js";
import { debugOnce } from "../../lib";
import { migrateLegacySupabaseSession } from "./authStorage";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_PUBLIC_KEY;

// Validate Supabase credentials
if (!supabaseUrl || !supabaseKey) {
  throw new Error(
    "❌ Supabase configuration missing. Set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_PUBLIC_KEY in .env"
  );
}

// Create Supabase client
migrateLegacySupabaseSession();

export const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    storage: window.localStorage,
    flowType: "pkce",
    detectSessionInUrl: true,
  },
  global: {
    headers: {
      "x-application-name": "finance-tracker",
    },
  },
  db: {
    schema: "public",
  },
});

debugOnce(
  "supabase:connected",
  "✅ Connected to Supabase",
  { url: supabaseUrl },
  "log"
);
